export const theme = {
  app: {
    fontFamily: "Source Sans Pro",
  },
  main: {
    backgroundColor: "#f0f4f5",
  },
};
